function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
  id: "a",
  d: "M0 0h20l10 9.75V40H0z"
}));

var _ref3 = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("mask", {
  id: "b",
  fill: "#fff"
}, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#a"
})), /*#__PURE__*/React.createElement("use", {
  fill: "#E3E7F4",
  fillRule: "nonzero",
  xlinkHref: "#a"
}), /*#__PURE__*/React.createElement("g", {
  mask: "url(#b)"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#CA64EA",
  fillRule: "nonzero",
  d: "M9.628 12.87h13.527c.467 0 .845.37.845.828v15.735c0 .22-.09.43-.248.585a.854.854 0 0 1-.597.243H9.628a.854.854 0 0 1-.598-.243.82.82 0 0 1-.247-.585V13.698c0-.458.378-.828.845-.828z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#CA64EA",
  fillRule: "nonzero",
  d: "M24 14.567a.82.82 0 0 0-.248-.585.854.854 0 0 0-.597-.243H9.628a.854.854 0 0 0-.598.243.82.82 0 0 0-.247.585v15.735c0 .22.089.43.247.586a.854.854 0 0 0 .598.242h9.934L24 18.087v-3.52z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#AE4BD5",
  fillRule: "nonzero",
  d: "M24 17.652h-4.348v4.478l2.174 2.044L24 22.13z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#9332BF",
  fillRule: "nonzero",
  d: "M24 22h-4.348v4.392l2.174 2.13L24 26.392z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#7719AA",
  fillRule: "nonzero",
  d: "M19.652 26.348H24v3.52c0 .457-.37.828-.828.828h-3.52v-4.348z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#000",
  fillRule: "nonzero",
  d: "M14.435 16.348H8.783v11.739h5.652c.48-.001.868-.37.87-.824V17.172c-.002-.455-.39-.823-.87-.824z",
  opacity: 0.1
}), /*#__PURE__*/React.createElement("path", {
  fill: "#000",
  fillRule: "nonzero",
  d: "M13.597 16.783H8.783v11.739h4.814a.833.833 0 0 0 .838-.824V17.606a.833.833 0 0 0-.838-.823z",
  opacity: 0.2
}), /*#__PURE__*/React.createElement("path", {
  fill: "#000",
  fillRule: "nonzero",
  d: "M13.597 16.783H8.783v10.87h4.814a.848.848 0 0 0 .838-.853v-9.165a.848.848 0 0 0-.838-.852z",
  opacity: 0.3
}), /*#__PURE__*/React.createElement("path", {
  fill: "#000",
  fillRule: "nonzero",
  d: "M12.768 16.783H8.783v10.87h3.985c.44-.002.796-.383.797-.853v-9.165c-.001-.47-.357-.851-.797-.852z",
  opacity: 0.2
}), /*#__PURE__*/React.createElement("path", {
  fill: "#7719AA",
  fillRule: "nonzero",
  d: "M4.87 16.783h8.695c.48 0 .87.356.87.797v7.97c0 .44-.39.798-.87.798H4.87c-.48 0-.87-.357-.87-.797V17.58c0-.44.39-.797.87-.797z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#FFF",
  fillRule: "nonzero",
  d: "M6.609 18.522h1.273l2.187 4.39c.114.19.2.342.256.457h.017a6.747 6.747 0 0 1-.037-.865v-3.982h1.086v6.521H10.2L7.92 20.72a3.442 3.442 0 0 1-.232-.448h-.02c.026.316.037.633.032.95v3.821H6.61v-6.521z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M4 12h20v20H4z"
})), /*#__PURE__*/React.createElement("path", {
  fill: "#CFD4E5",
  fillRule: "nonzero",
  mask: "url(#b)",
  d: "M20 0h10v10H20z"
}));

var SvgOnenote = function SvgOnenote(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 40,
    viewBox: "0 0 30 40",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgOnenote, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/onenote.21209083.svg";
export { ForwardRef as ReactComponent };